import React, { useEffect, useState } from 'react'
import { 
  CloseDiv,
   Header,
   ContainerOfModal,
   FormData,
   InputDiv,
   InputLabel,
   InputData,
   BottomDiv,
   ButtonContainer,
   ButtonDiv,
   SelectData, 
} from './style'
import { useNavigate, useParams } from 'react-router-dom'
import close from '../../assets/close-icon.svg'
import plus from '../../assets/productions/plus.svg'
import ModalTest from '../BaseModal'
import axios from 'axios'

const AddOpInPcp = () => {
  const [ machineOptions, setMachineOptions ] = useState([])
  const [ serviceOptions, setServiceOptions ] = useState([])
  const [ formData, setFormData ] = useState({
    machineId: '',
    serviceId: '',
  })
  const navigate = useNavigate()
  const { stageId } = useParams()
  const params = { stageId }

  const handleCreate = () => {
    axios.patch(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/service/${formData.serviceId}`, {
      machineId:Number(formData.machineId)
    })
    .then((response) => {
      if(response.data) navigate(-1)
    })
    .catch((error) => {
      console.error(error)
    })
  }

  useEffect(() => {
    handleGetAllMachines()
    handleGetAllServices()
  }, [])

  const handleGetAllMachines = () => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/pcp/machines`, {params})
    .then((response) => {
      if(response.data) setMachineOptions(response.data)
    })
    .catch((error) => {
      console.error(error)
    })
  }

  const handleGetAllServices = () => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/service`)
    .then((response) => {
      if(response.data) setServiceOptions(response.data)
    })
    .catch((error) => {
      console.error(error)
    })
  }

  return (
    <ModalTest>
      <ContainerOfModal>
        <Header>
          <h2>Adicionar OP</h2>
          <CloseDiv onClick={() => navigate(-1)}> <img src={close} /> </CloseDiv>
        </Header>
        <FormData>
          <InputDiv>
            <InputLabel>Máquina</InputLabel>
            <SelectData onChange={(e:any) => setFormData(prev => ({...prev, machineId:e.target.value}))}>
              <option value={formData.machineId}>Selecione</option>
              {machineOptions.map((machine:any, index) =>
                <option key={index} value={machine.id}>{machine.id}</option>
              )}
            </SelectData>
          </InputDiv>
          <InputDiv>
            <InputLabel>Selecionar OP</InputLabel>
            <SelectData onChange={(e:any) => setFormData(prev => ({...prev, serviceId:e.target.value}))}>
              <option value={formData.serviceId}>Selecione</option>
              {serviceOptions.map((service:any, index) =>
                <option key={index} value={service.id}>{service.id}</option>
              )}
            </SelectData>
          </InputDiv>
        </FormData>
        <BottomDiv>
          <ButtonContainer>
            <ButtonDiv onClick={(() => navigate(-1))} className='cancel'>Cancelar</ButtonDiv>
            <ButtonDiv onClick={() => handleCreate()}>
              <img src={plus} /> Adicionar OPs
            </ButtonDiv>
          </ButtonContainer>
        </BottomDiv>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default AddOpInPcp